import React from 'react'

const about = () => {
    return (
        <p>Test</p>
    )

}

export default about